import styled from 'styled-components';
import { PopoverProps } from '..';

const INDICATOR_SIZE = '20px';
const MARGIN_FOR_THE_POPOVER = '24px';

export const PopoverContainerWrapper = styled.div`
  position: relative;
  display: inline-block;
  height: min-content;
`;

export const PopoverWrapper = styled.div<PopoverProps>`
  min-width: 35px;
  visibility: hidden;
  opacity: 0;
  width: ${({ size }) => `${size}px`};
  background-color: ${({ backgroundColor }) => backgroundColor};
  text-align: center;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  transition: opacity 0.3s;
  filter: drop-shadow(rgba(0, 0, 0, 0.2) 0 2px 10px);
  padding: 8px 16px 16px 16px;

  &.visible {
    visibility: visible;
    opacity: 1;
  }

  &.bottom-left {
    top: 100%;
    margin-top: ${MARGIN_FOR_THE_POPOVER};
    right: ${({ correctTooltipPosition }) => `calc(-100% - ${correctTooltipPosition})`};
  }

  &.bottom-right {
    top: 100%;
    margin-top: ${MARGIN_FOR_THE_POPOVER};
    left: ${({ correctTooltipPosition }) => `calc(-100% - ${correctTooltipPosition})`};
  }

  &.top-left {
    bottom: 100%;
    margin-bottom: ${MARGIN_FOR_THE_POPOVER};
    right: ${({ correctTooltipPosition }) => `calc(-100% - ${correctTooltipPosition})`};
  }

  &.top-right {
    bottom: 100%;
    margin-bottom: ${MARGIN_FOR_THE_POPOVER};
    left: ${({ correctTooltipPosition }) => `calc(-100% - ${correctTooltipPosition})`};
  }

  &.bottom-center {
    top: 100%;
    margin-top: ${MARGIN_FOR_THE_POPOVER};
  }
`;

type IArrow = {
  backgroundColor: string;
};

export const Arrow = styled.div<IArrow>`
  position: absolute;
  border-style: solid;
  z-index: 1;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s;
  border-width: 0 ${INDICATOR_SIZE} ${INDICATOR_SIZE} ${INDICATOR_SIZE};
  border-color: ${({ backgroundColor }) => `transparent transparent ${backgroundColor}  transparent`};

  &.visible {
    visibility: visible;
    opacity: 1;
  }

  &.bottom-left,
  &.bottom-right {
    top: calc(100% + 4px);
    right: 50%;
    transform: translateX(50%);
  }

  &.top-left,
  &.top-right {
    bottom: calc(100% + 4px);
    right: 50%;
    transform: rotate(180deg) translateX(-50%);
  }
`;
